<template>
  <v-btn stacked @click="goToViewAll" class="top-nav-icon">
    <v-badge
      v-if="unreadMessageCount"
      color="green"
      :content="unreadMessageCountDisplay"
      overlap
    >
      <v-icon large>mdi-email</v-icon>
    </v-badge>
    <v-icon large v-else>mdi-email</v-icon>
  </v-btn>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { getReceivedMessages } from './api.js';
import { storeToRefs } from 'pinia';
import { useRootStore } from '../../stores/root';

const store = useRootStore();
const { userId, orgId, assumingUser } = storeToRefs(store);

const unreadMessageCount = ref();

const unreadMessageCountDisplay = computed(() => {
  if (unreadMessageCount.value > 99) {
    return '99+';
  }
  return unreadMessageCount.value;
});

async function fetchMessages() {
  try {
    const response = await getReceivedMessages({
      nextKey: null,
      limit: 5,
      dateSentAfter: null,
      isAssumingUser: assumingUser?.value ? userId.value : null,
    });
    unreadMessageCount.value =
      response?.data?.receivedMessages?.user?.unreadMessageCount || 0;
  } catch (_e) {
    // no-op for now
  }
}

onMounted(async () => {
  await fetchMessages();
});

watch(userId, () => {
  fetchMessages();
});

watch(orgId, () => {
  fetchMessages();
});

function goToViewAll() {
  window.location.href = '/portal/myq-messages';
}
</script>
